import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Tabs,
} from "antd";
import { withRouter } from "react-router-dom";
import { ContextAPI } from "../../../ContextAPI";
import { useHistory } from "react-router-dom";
import PaymentModal from "../../paymentModal";
import CustomerSpareTable from "./CustomerSpareTable";
import OrderManagementTable from "./OrderManagementTable";
import { platformApi } from "../../../api";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;
const { TabPane } = Tabs;

function index(props) {
  const history = useHistory();
  const { loginCredintials } = useContext(ContextAPI);
  const [spinning, setSpinning] = useState(false);
  const [dataSource, setData] = useState([]);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [editableData, setEditableData] = useState({})
  const [redirect, setRedirect] = useState(false);
  const [selected, setSelected] = useState();
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [search, setSearch] = useState('');
  const [gst, setGst] = useState();
  const [data, setDatas] = useState([]);
  const openPaymentModal = (row) => {
    setSelectedRow(row);
    setPaymentModalVisible(true);
  };

  const [activeTab, setActiveTab] = useState("1");
  const getMenu = () => {
    let size = count / 10 + (count % 10) ? 1 : 0;
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu), setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };
  const menu = <Menu>{getMenu()}</Menu>;

  const handleTabChange = (activeKey) => {
    setActiveTab(activeKey);
    switch (activeKey) {
      case "1":
        setPageData(search);
        break;
      case "2":
        setPage(1);
        setLimit(10);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setGst(loginCredintials.branch[0].gst);
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "customer_spare_order") {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
        }
      });
    setPageData();
    //getPSI();
  }, []);

  useEffect(() => {
    if (activeTab === "1") {
      setPageData(search);
    }
  }, [page, limit, search]);

  const downloadOrders = async () => {
    try {
      setSpinning(true);
      const response = await platformApi.get(
        `/api/customerSpareOrderRouter/downloadOrders`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Pending_SparePartOrders_${new Date().toISOString().slice(0, 10)}.csv`;
        link.click();
        message.success("Orders CSV downloaded successfully!");
      } else {
        message.error("No pending orders found");
      }
    } catch (err) {
      console.error("Error downloading:", err);
      message.error("Failed to download CSV");
    } finally {
      setSpinning(false);
    }
  };


  const setPageData = (search, val) => {
    setSpinning(true)
    platformApi
      .post(`/api/customerSpareOrderRouter/get`, {
        page: val ? val : page,
        size: limit,
        searchString: search,
      })
      .then((result) => {
        setSpinning(false);
        let { data } = result;
        if (data.code === 200) {
          setData(data.response.data?.customerSpareOrder);
          setCount(data.response.data?.count);
        } else {
          message.error("Unable to fetch Customer Spare Order", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Vehicle Spare Purchase Invoice : ", error);
        message.error("Unable to fetch Customerss Spare Order", 2);
      });
  };


  const deleteData = (id) => {
    setSpinning(true)
    platformApi
      .delete(`/api/customerSpareOrderRouter/${id}`)
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            message.success("Deleted Successfully")
            setPageData();
          } else {
            message.error(response.message || "Couldn't Remove Customer Spare Order");
          }
        }
        else {
          message.error("Couldn't Remove Customer Spare Order");
        }
        setSpinning(false)
      }).catch((err) => {
        setSpinning(false)
        message.error("Unable to Delete Customer Spare Order");
      });
  }

  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          Customer Spare Order [{count}]
          <span style={{ margin: ".5rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp; &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder={activeTab == "1" ? "Search Customer Spare" : "Search Spare Parts"}
          onSearch={(event) => {
            setPage(1);
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null);
              setPage(1);
            }
          }}
        />

        {activeTab === "2" && (
          <Button
            type="primary"
            icon="download"
            style={{ marginLeft: 10 }}
            onClick={downloadOrders}
          >
            Download Orders
          </Button>
        )}

        <Button
          onClick={() =>
            history.push({
              pathname: `/autoadmin/customerspare/:id`,
              state: {
                editable: true,
              },
            })
          }
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Customer Spare Order
        </Button>

      </div>

      <Tabs activeKey={activeTab} onChange={handleTabChange}>
        <TabPane tab={<span>Customer Spare Order</span>} key="1">
          <CustomerSpareTable
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              defaultCurrent: 1,
              current: page,
              total: count,
              showQuickJumper: true,
            }}
            dataSource={dataSource}
            spinner={{ spinning }}
            delete={deleteData}
            deleteAccess={deleteAccess}
            refreshData={setPageData}
            modifyAccess={modifyAccess}
            loginCredintials={loginCredintials}
            openModal={openPaymentModal}
          />
        </TabPane>
        <TabPane tab={<span>Order Management</span>} key="2">
          {activeTab === "2" &&
            <OrderManagementTable
              key="order-management"
              pagination={{
                onChange: (page) => {
                  setPage(page);
                },
                pageSize: limit,
                defaultCurrent: 1,
                current: page,
                total: count,
                showQuickJumper: true,
              }}
              modifyAccess={modifyAccess}
              deleteAccess={deleteAccess}
              data={data}
              setData={setDatas}
              setCount={setCount}
              searchString={search}
              page={page}
              limit={limit}
            />}
        </TabPane>
      </Tabs>
    </div>
  )
}

export default withRouter(index)
